import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import ActionsMenu from "../../../../../../../ui/ActionsMenu";
import CreateNew from "./CreateNew";
import CreateFromExisting from "./CreateFromExisting";
import useCreatePerson from "../../../../../../hooks/useCreatePerson";
import EmployeeCard from "./EmployeeCard";
import { Grid } from "@material-ui/core";
import EmployeeFilters from "./EmployeeFilters";

const defaultData = {
  createNewOpened: false,
  addExistingOpened: false
};

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    color: "#000000"
  },
  block: {},
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 12
  },
  avatarContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& > span": {
      marginLeft: 10
    }
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  employees: {
    paddingTop: 16
  }
});

const returnEmployees = (employees, filter, depId) => {
  switch (filter) {
    case "registered":
      return employees.filter(emp => depId > -1 ? (emp.sysState === 1 && emp.departmentId === depId) : emp.sysState === 1);
    case "fired":
      return employees.filter(emp => depId > -1 ? (emp.endDate && emp.departmentId === depId) : emp.endDate);
    case "all":
    default:
      return employees.filter(emp => depId > -1 ? emp.departmentId === depId : emp);
  }
};

const Employees = ({ classes, id, orgName, depId }) => {
  const [filter, setFilters] = React.useState(null);
  const [data, setData] = React.useState(defaultData);

  const {
    createData,
    createNewPerson,
    addExistingPerson,
    getStaff
  } = useCreatePerson();

  useEffect(() => {
    getStaff(id, depId);
  }, [depId, getStaff, id]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
  };

  const actions = [
    {
      label: "Добавить нового",
      onClick: () => onChange("createNewOpened", true)
    },
    {
      label: "Выбрать из существующих",
      onClick: () => onChange("addExistingOpened", true)
    }
  ];

  return (
    <div className={classes.root}>
      <CreateNew
        open={data.createNewOpened}
        handleClose={() => onChange("createNewOpened", false)}
        createRoom={data => {
          createNewPerson(id, data);
          onChange("createNewOpened", false);
        }}
        orgName={orgName}
        isCreatingRoom={false}
      />
      <CreateFromExisting
        open={data.addExistingOpened}
        handleClose={() => onChange("addExistingOpened", false)}
        createRoom={data => {
          addExistingPerson(id, data);
          onChange("addExistingOpened", false);
        }}
        orgId={id}
        orgName={orgName}
        isCreatingRoom={false}
      />
      <div className={classes.top}>
        <Typography className={classes.heading}>Сотрудники</Typography>
        <EmployeeFilters returnFilter={setFilters} />
        <ActionsMenu actions={actions} />
      </div>
      <div className={classes.employees}>
        <Grid container spacing={2}>
          {returnEmployees(createData.staff, filter, depId).map((employee,idx) => (
            <Grid key={`emp_grid_${id}_${idx}`} item xs={12} sm={12} md={6} lg={4}>
              <EmployeeCard
                data={employee}
                orgId={id}
                update={() => getStaff(id)}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default withStyles(styles)(Employees);
